import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendNewPasswordRequest } from "../../services/APIService";

export interface ForgetPasswordState {
  email: string;
  emailError: string;
  showPopup: boolean;
}

export const useForgetPasswordVM = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const onButtonClick = async () => {
    setEmailError("");

    if (email === "") {
      setEmailError("Bitte E-Mail Adresse eingeben");
      return;
    }

    try {
      const data = await sendNewPasswordRequest(email);
      const mailStatus = data["message"];

      if (mailStatus !== "E-Mail not exist") {
        setShowPopup(true);
      } else {
        navigate("/Login");
      }
    } catch (error) {
      console.error("Fehler beim Zurücksetzen des Passworts:", error);
    }
  };

  const onButtonSendClick = () => {
    setShowPopup(false);
    navigate("/Login");
  };

  return {
    state: {
      email,
      emailError,
      showPopup,
    },
    actions: {
      setEmail,
      onButtonClick,
      onButtonSendClick,
    },
  };
};